import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroAltaCostura from './components/HeroAltaCostura';
import GallerySection from './components/GallerySection';
import ProcessSection from './components/ProcessSection';
import PressSection from './components/PressSection';
import BookingCalendar from './components/BookingCalendar';
import { useSEO } from '../../hooks/useSEO';
import { SchemaMarkup } from '../../components/SEOHead';

const serviceSchema = {
  '@context': 'https://schema.org',
  '@type': 'Service',
  name: 'Alta Costura Anthony Sánchez',
  provider: {
    '@type': 'LocalBusiness',
    name: 'Anthony Sánchez Couture',
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'Rambla de Catalunya, 85, Principal - 2',
      addressLocality: 'Barcelona',
      addressRegion: 'Cataluña',
      postalCode: '08008',
      addressCountry: 'ES',
    },
  },
  areaServed: {
    '@type': 'City',
    name: 'Barcelona',
  },
  description: 'Diseño y confección de vestidos de alta costura a medida en Barcelona. Bordados en oro, encajes y tejidos exclusivos.',
  serviceType: 'Alta Costura',
  priceRange: '€€€€',
};

const breadcrumbSchema = {
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    {
      '@type': 'ListItem',
      position: 1,
      name: 'Inicio',
      item: 'https://anthonysanchezc.com',
    },
    {
      '@type': 'ListItem',
      position: 2,
      name: 'Alta Costura',
      item: 'https://anthonysanchezc.com/alta-costura',
    },
  ],
};

export default function AltaCostura() {
  useSEO({
    title: 'Alta Costura Barcelona | Vestidos de Gala a Medida | Anthony Sánchez Couture',
    description: 'Vestidos de alta costura exclusivos en Barcelona. Diseño a medida, bordados en oro, encajes franceses y tejidos de alta calidad. Reserva cita privada en el Eixample.',
    keywords: 'alta costura Barcelona, haute couture, vestidos gala, bordados oro, vestidos novia Barcelona, diseñador moda, confección a medida, Eixample',
    canonical: '/alta-costura',
    ogTitle: 'Alta Costura Barcelona — Vestidos de Gala a Medida',
    ogDescription: 'Diseñamos y confeccionamos vestidos de gala únicos en Barcelona. Artesanía exclusiva, bordados en oro y tejidos de lujo.',
    ogType: 'website',
  });

  return (
    <div className="min-h-screen bg-white">
      <SchemaMarkup schema={serviceSchema} />
      <SchemaMarkup schema={breadcrumbSchema} />
      <Navbar />
      <main>
        <HeroAltaCostura />
        <GallerySection />
        <ProcessSection />
        <PressSection />
        <BookingCalendar />
      </main>
      <Footer />
    </div>
  );
}